import Head from "next/head";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import styles from "../styles/components/Home.module.scss";
import React, { useState, useEffect } from "react";
import useTranslation from "next-translate/useTranslation";
import { isServer } from "../helpers/common";
const Footer = dynamic(() => import("../components/Footer"));
const Header = dynamic(() => import("../components/Header"));
const Heading = dynamic(() => import("../components/Heading"));
const SubscribeCard = dynamic(() => import("../components/SubscribeCard"));

function Subscribe({
  authKeys,
  subscriptions,
  subscriptionInfo,
  userDetails,
  signupBook,
  fullUrl,
  origin,
}) {
  const { t } = useTranslation();
  const router = useRouter();
  const { locale } = router;
  const url = `${origin}${fullUrl}`;
  const tempCode = locale.substring(0, 2).toUpperCase();
  const defaultImage = `${origin}/cdn/images/nextory-share-pink.jpg`;
  const isLoggedIn = userDetails.isLoggedIn;
  const [currentPage, setCurrentPage] = useState('');
  const menu = !isLoggedIn ? "noBg" : "registeredUser";

  useEffect(() => {
    if(!isServer){
      setCurrentPage(window.location.href);
    }

  }, []);

  return (
    <>
      <Head>
        <title>{t("lang_common:seo.title")}</title>
        <link rel="alternate" href={`${origin}`} hrefLang={tempCode} />
        <meta httpEquiv="Content-Language" content={locale} />
        <meta name="name" content={t(`lang_seo:generic.title`)} />
        <meta name="description" content={t("lang_common:seo.description")} />
        <meta name="image" content={defaultImage} />
        <meta
          name="og:description"
          content={t(`lang_seo:generic.ogDescription`)}
        />
        <meta name="og:title" content={t("lang_seo:generic.ogTitle")} />
        <meta name="og:site_name" content={t("lang_seo:generic.ogSiteName")} />
        <meta name="og:image" content={defaultImage} />
        <meta name="og:url" content={url} />
        <meta name="fb:app_id" content={`${process.env.FB_ID}`} />
        <link
          rel="preload"
          href="/fonts/body/nextorysans-medium.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/body/nextorysans-regular.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/headline/nextorysans-headline-demibold.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link rel="canonical" href={url} data-react-helmet="true"></link>
      </Head>
      <div id="newUI" className={styles.app}>
        <main className={styles.main}>
          <Header
            authKeys={authKeys}
            subscriptions={subscriptions}
            subscriptionInfo={subscriptionInfo}
            userDetails={userDetails}
            signupBook={signupBook}
            noBackground={menu}
            searchIcon={"dark"}
            modifiers={"investors"}
          />

          {/* Subscribe */}
          <Heading center header={"Subscribe"} />
          <SubscribeCard
            uniqueIdentifier={process.env.CISION_SUBSCRIPTION_KEY}
            successUrl={`${currentPage}?success=true`}
            failureUrl={`${currentPage}?failure=true`}
            successMsg={
              router.query && router.query.success
                ? `Thank you for subscribing!`
                : null
            }
            failureMsg={
              router.query && router.query.failure
                ? `You've already subscribed to this newsletter!`
                : null
            }
          />
          <Footer spaceTop userDetails={userDetails} />
        </main>
      </div>
    </>
  );
}

export default Subscribe;
